import React from "react";
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup } from "@material-ui/core";
import TextInput from "../../../sharedComponents/textInput/textInput";
import RiskName from "../riskName/riskName";
import { CalculateStore } from "../../../../stores/calculateStore";
import { inject, observer } from "mobx-react";
import { RisksId } from "../../../../helpers/risk";
import { LegalProtectionVariant, LegalProtectionVariants } from "../../../../helpers/legalProtection";
import { displayAdditionalRiskForm } from "../../../../helpers/risksNetwork";
import Notification from "../../../sharedComponents/notification/notification";
import { runInAction } from "mobx";

interface LegalProtectionProps {
  calculateStore?: CalculateStore;
}

@inject("calculateStore")
@observer
export default class LegalProtection extends React.Component<LegalProtectionProps> {
  public render() {
    const calculateStore = this.props.calculateStore!;
    const legalProtection = calculateStore.additionalInsurances.legalProtection;
    const displayForm = displayAdditionalRiskForm(calculateStore.additionalInsurances.legalProtection);

    return (<div className="section legal-protection">
      <RiskName
        checkboxOnChange={(event) => {
          calculateStore.setAdditionalInsuranceFieldChecked(RisksId.legalProtection, event.target.checked);
        }}
        riskId={RisksId.legalProtection}
        displayIcon={true}
      />

      {displayForm && (
        <div className="risk-value">
          {this.renderRadioGroup()}
          <TextInput
            disabled={true}
            className="rate"
            value={legalProtection.rate || "?"}
            topLabel="Składka (zł)"
          />
        </div>
      )}

    </div>);
  }

  private renderRadioGroup() {
    const legalProtection = this.props.calculateStore!.additionalInsurances.legalProtection;
    const onChange = (event: any) => {
      this.props.calculateStore!.setLegalProtectionVariant(event.target.value);
      runInAction(() => {
        // TODO: create setter and remove 'runInAction'
        legalProtection.errorMessage = "";
      });
    };

    return (<FormControl>
      <RadioGroup
        onChange={onChange}
        value={legalProtection.variant}
        className={legalProtection.errorMessage ? "has-error" : ""}>
        {LegalProtectionVariants.map((variant) => this.renderOption(variant.value, variant.label, variant.sumLabel))}
      </RadioGroup>
      {legalProtection.errorMessage && (
        <FormHelperText>
          <Notification type="error" message={legalProtection.errorMessage} />
        </FormHelperText>
      )}
    </FormControl>);
  }

  private renderOption(value: LegalProtectionVariant, label: string, sumLabel: string) {
    return (
      <FormControlLabel
        key={"option_" + value} value={value} control={<Radio />}
        label={
          <div className={"option option_" + value}>
            <div className="option-label">
              {label}
            </div>
            <div className="option-value">
              {sumLabel}
            </div>
          </div>
        }
      />
    );
  }
}
